module.exports = __webpack_public_path__ + "img/a_l3.eb9c461e.png";